import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5ec76552"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "main"
}, [/*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "软件开发")])], -1));
import Cards from './components/cards/cards.vue';
import Display from './components/display/display.vue';
import Process from './components/process/process.vue';
import Certificate from './components/certificate/certificate.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createVNode(Cards), _createVNode(Display), _createVNode(Process), _createVNode(Certificate)], 64);
    };
  }
});